import * as Cesium from 'cesium';
import styled from "styled-components";
import { Tooltip } from '@mui/material';
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { CollectionCategoryEnum } from 'Enums';
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useViewerStore from '../../store-zustand/viewer';
import { showAlert, turnOffLayers } from '../../helper';
import useProjectStore from '../../store-zustand/project';
import { getLayerCollectionDetail } from '@/utils/helpers';
import TooltipIconButton from "components/TooltipIconButton";
import { Zoomtopoint } from "../../components/MapView/MapUtils";
import { VisibilityOffOutlined, CreateOutlined, DeleteOutlined, VisibilityOutlined, TonalityOutlined, ContrastOutlined } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
  tooltip: {
    color: "white",
    fontSize: "12px !important",
    backgroundColor: "#5A5A5A",
    borderRadius: 3,
    fontFamily: "Roboto",
    padding: "8px 10px",
    fontWeight: 500,
  },
}));

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  line-height: 24px;
  font-size: 15px;
  font-weight: 400;
  padding: 0rem 2.5rem;
  height: fit-content;
  min-height:50px;
  color: ${({ theme }) => theme.textColor.secondary};
  transition: all 0.35s;

  .main-text {
    display: flex;
    align-items: center;
    
    svg {
      width: 24px;
      height: 24px;
      margin-right: 24px;
    }
  }

  .layer-span {
    display: none;
    min-width: 135px;
    justify-content: flex-end;
      
    .active-style {
      fill: ${({ theme }) => theme.textColor.accent} !important;
    }
  }

  &.active, &:hover {
    background-color: rgba(35, 35, 35, 0.8);
    color: #e5e5e5;

    .layer-span {
      display: flex;
    }
  }
`;

const AccordionItem = ({
  icon: Icon,
  keyword,
  label,
  type,
  LayerId,
  onClick,
  onChangeVisible,
  onEdit,
  onDelete,
  twoDSwitcher,
  defaultvisibility,
  annotationId,
  actualannotationIDwithVisibility,
  lastaddedannotation,
  annotationIndex,
  menutype,
  bbox,
  visibility,
  description
}) => {
  const [isLayerMosaic, setIsLayerMosaic] = useState();
  const [isLayerTerrain, setIsLayerTerrain] = useState();
  const [isLayerPanorama, setIsLayerPanorama] = useState();
  const [isLayerOblique, setIsLayerOblique] = useState();
  const [visible, setVisible] = useState(defaultvisibility);
  const [Hide3DTerrain, setHide3DTerrain] = useState(defaultvisibility);
  const [terrainVisible, setTerrainVisible] = useState(false);
  const [mosaicVisible, setMosaicVisible] = useState(false);
  const [panoramaVisible, setPanoramaVisible] = useState(false);
  const [obliqueVisible, setObliqueVisible] = useState(false);
  const [greyscaleActive, setGreyscaleActive] = useState(false);
  const [nirActive, setNirActive] = useState(false);
  const [hillshadeActive, setHillshadeActive] = useState(false);
  const [ThreeDtitle, setThreeDtitle] = useState(defaultvisibility ? 'Disable' : 'Enable');
  const selectedImageryMode = useSelector(state => state.asset.selectedImageryMode);
  const selectedMission = useSelector(state => state.asset.selectedMission);
  const [selectedCollection, setSelectedCollection] = useState();
  const { setproject_id, getprojectdataByid } = useProjectStore();
  const { viewer } = useViewerStore();
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChangeVisible = (flag, annotation, index) => {
    setVisible(flag);
    if (onChangeVisible) onChangeVisible(flag);

    if (menutype === 'AllProject') {
      if (flag === false) {
        let bboxString = bbox;
        bboxString = bboxString.replace('[', '');
        bboxString = bboxString.replace(']', '');
        bboxString = bboxString.replaceAll("'", '');
        bboxString = bboxString.split(",");

        Zoomtopoint(viewer, parseFloat(bboxString[0]), parseFloat(bboxString[2]));
      }
    } else {
      actualannotationIDwithVisibility(flag, annotation, index);
    }
  };

  useEffect(() => {
    if (lastaddedannotation === undefined) return;
    if (lastaddedannotation === annotationId) setVisible(false);
  }, [])

  useEffect(() => {
    if (selectedCollection === undefined) return;
    
    const isTerrain = [CollectionCategoryEnum.terrain_mosaic, CollectionCategoryEnum.terrain_tileset].includes(selectedCollection.category);
    setTerrainVisible(isTerrain);
    setIsLayerTerrain(isTerrain);

    const isMosaic = [CollectionCategoryEnum.ortho_photo_mosaic, CollectionCategoryEnum.ortho_photo_tileset].includes(selectedCollection.category);
    setMosaicVisible(isMosaic);
    setIsLayerMosaic(isMosaic);

    const isPanorama = selectedCollection.category === CollectionCategoryEnum.streetview;
    setPanoramaVisible(isPanorama);
    setIsLayerPanorama(isPanorama);

    const isOblique = [CollectionCategoryEnum.oblique_photo_mosaic, CollectionCategoryEnum.oblique_photo_tileset].includes(selectedCollection.category);
    setObliqueVisible(isOblique);
    setIsLayerOblique(isOblique);

    if (window.HDImagery[selectedMission] !== undefined && !window.HDImagery[selectedMission][selectedImageryMode]) {
      setGreyscaleActive(false);
      setNirActive(false);
      setHillshadeActive(false);
      
      if (isLayerTerrain){
        dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'schwarzwald' });
      } else {
        dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'rgb' });
      }
    }
  }, [selectedCollection])
  
  useEffect(() => {
    if (selectedMission === undefined) return;
    let [, collection] = getLayerCollectionDetail(selectedMission);
    setSelectedCollection(collection);
  }, [selectedMission])

  const GetProjectInfoBeforeEditing = async (keyword) => {
    dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
    dispatch({ type: 'TOGGLE_MAP_TOOL', show: true });
    dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: true });
    const projectinfo = await getprojectdataByid(keyword);
    setproject_id(projectinfo[0].pk);
  }

  const HideLayers = () => {
    if (isLayerOblique) dispatch({ type: 'TOGGLE_OBLIQUE_MODAL', show: false });
    turnOffLayers();
  }

  const ShowLayer = () => {
    if (isLayerOblique) dispatch({ type: 'TOGGLE_OBLIQUE_MODAL', show: true });
    if (window.HDImagery[window.selectedHDImagery]){
      if (window.HDImagery[window.selectedHDImagery][selectedImageryMode]) {
        window.HDImagery[window.selectedHDImagery][selectedImageryMode].show = true;
      } else {
        if (isLayerTerrain){
          window.HDImagery[window.selectedHDImagery]['schwarzwald'].show = true;
          dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'schwarzwald' });
        } else if (isLayerOblique) {
          window.HDImagery[window.selectedHDImagery]['rgb'].show = true;
          dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'rgb' });
        } else {
          window.HDImagery[window.selectedHDImagery]['rgb'].show = true;
          dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'rgb' });
        }
      }
    } 
  }

  const LayerManager = () => {
    if (selectedMission === undefined) return;
    if ([3, 4, 5, 6].includes(LayerId)) {
      const layerTypes = [
        { check: isLayerMosaic, visible: mosaicVisible, setVisible: setMosaicVisible },
        { check: isLayerTerrain, visible: terrainVisible, setVisible: setTerrainVisible },
        { check: isLayerPanorama, visible: panoramaVisible, setVisible: setPanoramaVisible },
        { check: isLayerOblique, visible: obliqueVisible, setVisible: setObliqueVisible }
      ];

      for (const { check, visible, setVisible } of layerTypes) {
        if (check) {
          setVisible(!visible);
          setThreeDtitle(visible ? 'Disable' : 'Enable');
          if (visible) {
            HideLayers();
          } else {
            ShowLayer();
          }
          break;
        }
      } 
    } else if (LayerId === 2) {
      if (Hide3DTerrain === false) {
        Cesium.IonResource.fromAssetId(2275207).then((resource) => {
          Cesium.Cesium3DTileset.fromUrl(resource).then(tileset => {
              window.buildingsLayer = tileset;
              window.MAIN_CESIUM_VIEWER.scene.primitives.add(tileset);
            });
        }).catch(() => {
          showAlert('error', 'Failed to retrieve the 3D Tileset Resource from Cesium Ion.');
        }).then(() => {
          setThreeDtitle('Disable');
          setHide3DTerrain(true);
        });
      } else {
        viewer.scene.primitives.remove(window.buildingsLayer);
        setThreeDtitle('Enable');
        setHide3DTerrain(false);
      }
    } else if (LayerId === 1) {
      const layers = viewer.scene.imageryLayers;
      for (var i = 0; i < layers._layers.length; i++) {
        if (i > 0) {
          if (layers._layers[i].imageryProvider._resource.url.includes('ckfxzc4360qmr19qoq0r55h9z')) {
            const response = layers.remove(layers._layers[i], true);
            if (response === true) {
              i = 0;
            }
          }
        }
      }
      if (Hide3DTerrain === false) {
        viewer.imageryLayers.addImageryProvider(
          new Cesium.MapboxStyleImageryProvider({
            username: 'fastmap',
            styleId: 'ckfxzc4360qmr19qoq0r55h9z',
            accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g',
            tilesize: 512,
            maximumLevel: 22
          })
        );
        setThreeDtitle('Disable');
        setHide3DTerrain(true);
      }
      else {
        setThreeDtitle('Enable');
        setHide3DTerrain(false);
      }
    } else if (LayerId === 0) {
      const layers = viewer.scene.imageryLayers;
      for (var j = 0; j < layers._layers.length; j++) {
        if (j > 0) {
          if (layers._layers[j].imageryProvider._resource.url.includes('ckg06e2k90bww19nsyropasfz')) {
            const response = layers.remove(layers._layers[j], true);
            if (response === true) {
              j = 0;
            }
          }
        }
      }
      if (Hide3DTerrain === false) {
        viewer.imageryLayers.addImageryProvider(
          new Cesium.MapboxStyleImageryProvider({
            username: 'fastmap',
            styleId: 'ckg06e2k90bww19nsyropasfz',
            accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g',
            tilesize: 512,
            maximumLevel: 22
          })
        );
        setThreeDtitle('Disable');
        setHide3DTerrain(true);
      }
      else {
        setThreeDtitle('Enable');
        setHide3DTerrain(false);
      }
    }
  }

  const toggleGreyscale = () => {
    if (selectedImageryMode !== "greyscale") {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'greyscale' });
      setGreyscaleActive(true);
      setNirActive(false);
      setHillshadeActive(false);
      window.style.mosaic = 'greyscale';
    } else {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'rgb' });
      setGreyscaleActive(false);
      setNirActive(false);
      setHillshadeActive(false);
      window.style.mosaic = 'rgb';
    }
  }

  const toggleNir = () => {
    if (selectedImageryMode !== "nir") {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'nir' });
      setGreyscaleActive(false);
      setNirActive(true);
      setHillshadeActive(false);
      window.style.mosaic = 'nir';
    } else {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'rgb' });
      setGreyscaleActive(false);
      setNirActive(false);
      setHillshadeActive(false);
      window.style.mosaic = 'rgb';
    }
  }

  const toggleHillshade = () => {
    if (selectedImageryMode !== "hillshade") {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'hillshade' });
      setGreyscaleActive(false);
      setNirActive(false);
      setHillshadeActive(true);
      window.style.terrain = 'hillshade';
    } else {
      dispatch({ type: 'SET_SELECTED_IMAGERY_MODE', selectedImageryMode: 'schwarzwald' });
      setGreyscaleActive(false);
      setNirActive(false);
      setHillshadeActive(false);
      window.style.terrain = 'schwarzwald';
    }
  }

  const handleOnClick = (e) => {
    if (e.target.getAttribute("name") === "wrapper") {
      if (type === "asset") {
        setVisible(false);
      }
      onClick()
    }
  }

  return (
    <Wrapper onClick={handleOnClick} name="wrapper">
      <Tooltip classes={classes} title={description || ''} placement="top"> 
        <div className="main-text" name="wrapper">
          {Icon}
          {label}
        </div>
      </Tooltip>
      <span className="layer-span">
        {type === "layer" ?
            <span>
              {LayerId === 3 ?
                <span>
                  <TooltipIconButton title={greyscaleActive ? 'RGB': 'Greyscale'} ariaLabel={"Greyscale"} placement="top" size={44} onClick={toggleGreyscale} disabled={!isLayerMosaic || !mosaicVisible}>
                    <ContrastOutlined className={greyscaleActive ? 'active-style' : ''}/>
                  </TooltipIconButton>
                  <TooltipIconButton title={nirActive ? 'RGB': 'NIR'} ariaLabel={"NIR"} placement="top" size={44} onClick={toggleNir} disabled={!isLayerMosaic || !mosaicVisible}>
                    <TonalityOutlined className={nirActive ? 'active-style' : ''}/>
                  </TooltipIconButton>
                  <TooltipIconButton title={ThreeDtitle} ariaLabel={ThreeDtitle} placement="top" size={44} onClick={LayerManager} disabled={!isLayerMosaic}>
                    {mosaicVisible ? < VisibilityOutlined className='active-style' /> : < VisibilityOffOutlined /> }
                  </TooltipIconButton>
                </span>
              : LayerId === 4 ?
                <span>
                  <TooltipIconButton title={hillshadeActive ? 'Schwarzwald' : 'Hillshade'} ariaLabel={"Hillshade"} placement="top" size={44} onClick={toggleHillshade} disabled={!isLayerTerrain || !terrainVisible} >
                    <TonalityOutlined className={hillshadeActive ? 'active-style' : ''}/>
                  </TooltipIconButton>
                  <TooltipIconButton title={ThreeDtitle} ariaLabel={ThreeDtitle} placement="right" size={44} onClick={LayerManager} disabled={!isLayerTerrain}>
                    {terrainVisible ? < VisibilityOutlined className='active-style' /> : < VisibilityOffOutlined /> }
                  </TooltipIconButton>
                </span>
              : LayerId === 5 ?
              <span>
                <TooltipIconButton title={ThreeDtitle} ariaLabel={ThreeDtitle} placement="right" size={44} onClick={LayerManager} disabled={!isLayerPanorama}>
                  {panoramaVisible ? < VisibilityOutlined className='active-style' /> : < VisibilityOffOutlined /> }
                </TooltipIconButton>
              </span>
              : LayerId === 6 ?
              <span>
                <TooltipIconButton title={ThreeDtitle} ariaLabel={ThreeDtitle} placement="right" size={44} onClick={LayerManager} disabled={!isLayerOblique}>
                  {obliqueVisible ? < VisibilityOutlined className='active-style' /> : < VisibilityOffOutlined /> }
                </TooltipIconButton>
              </span>
            : (![3, 4, 5, 6].includes(LayerId)) ?
                <TooltipIconButton title={ThreeDtitle} ariaLabel={ThreeDtitle} placement="right" size={44} onClick={LayerManager} >
                  {Hide3DTerrain === false ? < VisibilityOffOutlined /> : < VisibilityOutlined className='active-style'/>}
                </TooltipIconButton> : null
              }
            </span> 
            :
            <span>
              {type === "asset" ? visibility ?
                <TooltipIconButton title="Visibility" ariaLabel="visibility" placement="bottom" onClick={() => {onChangeVisible()}} size={44}>
                  <VisibilityOffOutlined />
                </TooltipIconButton> 
                : (<TooltipIconButton title="Invisibility" ariaLabel="visibility" placement="bottom" onClick={() => {onChangeVisible()}} size={44}>
                    <VisibilityOutlined className='active-style'/>
                  </TooltipIconButton>) 
                :
                <></>
              }
              {type === "annotation" ? visible ?
                (<TooltipIconButton title="Visibility" ariaLabel="visibility" placement="bottom" onClick={() => handleChangeVisible(false, annotationId, annotationIndex)} size={44}>
                  <VisibilityOffOutlined />
                </TooltipIconButton>) 
                : 
                (<TooltipIconButton title="Invisibility" ariaLabel="visibility" placement="bottom" onClick={() => {handleChangeVisible(true, annotationId, annotationIndex)}} size={44}>
                  <VisibilityOutlined className='active-style'/>
                </TooltipIconButton>)
                :
                <></>
              }
              {menutype === 'AllProject' ?
                <Link to={`/projects/${keyword}`}>
                  <TooltipIconButton title="Edit" ariaLabel="edit" placement="bottom" onClick={() => {GetProjectInfoBeforeEditing(keyword)}} size={44}>
                    <CreateOutlined />
                  </TooltipIconButton>
                </Link> 
                : 
                <TooltipIconButton title="Edit" ariaLabel="edit" placement="bottom" onClick={() => {onEdit()}} size={44}>
                  <CreateOutlined />
                </TooltipIconButton>
              }
              <TooltipIconButton title="Delete" ariaLabel="delete" placement="bottom" onClick={() => { onDelete() }} size={44}>
                <DeleteOutlined />
              </TooltipIconButton>
            </span>
        }
      </span>
    </Wrapper >
  );
};

export default AccordionItem;